module.exports = __webpack_public_path__ + "img/bg-scopen.96a363fc.jpg";